(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Payment History Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, UserSession,$rootScope,loggerService,loggerServiceHelper) {
    // console.log("Payment History Controller Func: ", $scope);
    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED)+loggerServiceHelper.setFlow("paymentHistory"));
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));
    var _history = UserSession.accountData.paymentHistory;
    $scope.wcmContent = wcmContent;
    $scope.hideDrugs = true;
    $scope.pagination = {
      list: [],
      showing: 12,
      perPage: 12,
      show: 12
    };

    //  Show Next set of transactions
    $scope.stDate = new Date().getTime();
    $scope.eDate = Date.now();
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.getStartDate = function(exportHistory){
      var paymentHistoryFilter = angular.copy($scope.session.accountData.pHistoryObj);
      if(exportHistory.rangeSelection=='custom' && exportHistory && exportHistory.customFrom){
        $scope.stDate = new Date(exportHistory.customFrom.label.split(". ")[1], (months.indexOf(exportHistory.customFrom.label.split(". ")[0])),1);
        //$scope.eDate = new Date(exportHistory.customTo.label.split(". ")[1], (months.indexOf(exportHistory.customTo.label.split(", ")[0])), new Date().getDate());
        var startTs = $scope.stDate.getTime(),
            endTs = $scope.eDate.getTime();
        paymentHistoryFilter = paymentHistoryFilter.filter(function (el) {
          var ts = (new Date(el.txnDate)).getTime();
          return ts >= startTs && ts <= endTs;
        });
        $scope.session.accountData.paymentHistory = paymentHistoryFilter;
        $scope.nextItem($scope.session.accountData.paymentHistory.length);
        //$scope.pagination.perPage = $scope.session.accountData.paymentHistory.length;
      }
    };

    $scope.getEndDate = function(exportHistory){
      var paymentHistoryFilter = angular.copy($scope.session.accountData.pHistoryObj);
      if(exportHistory.rangeSelection=='custom' && exportHistory && exportHistory.customTo){
        $scope.stDate = new Date(exportHistory.customFrom.label.split(". ")[1], (months.indexOf(exportHistory.customFrom.label.split(". ")[0])),1);
      $scope.eDate = new Date(exportHistory.customTo.label.split(". ")[1], (months.indexOf(exportHistory.customTo.label.split(". ")[0])+1),0);

        var startTs = $scope.stDate.getTime(),
            endTs = $scope.eDate.getTime();
        paymentHistoryFilter = paymentHistoryFilter.filter(function (el) {
          var ts = (new Date(el.txnDate)).getTime();
          return ts >= startTs && ts <= endTs;
        });
        $scope.session.accountData.paymentHistory = paymentHistoryFilter;
        $scope.nextItem($scope.session.accountData.paymentHistory.length);
      }
    };

    $scope.processHistory = function(paymentHistory){
        return paymentHistory.filter(function (el) {
            var ts = (new Date(el.txnDate)).getTime();
            el.txnDateTemp = ts;
            return ts;
        });
    }
      /**
       * IM5933681 - Fix for sorting payment history in UI - SP 01/29/2018
       * @param exportHistory
       */
    $scope.getStEtDate = function (exportHistory) {
      $scope.stDate = new Date($scope.startDate());
      $scope.eDate = new Date();
      var paymentHistoryFilter = angular.copy($scope.session.accountData.pHistoryObj);
      $scope.nextItem($scope.session.accountData.paymentHistory.length);
      if(exportHistory.rangeSelection === 'ytd'){
        var year = new Date().getFullYear();
        var startTs = (new Date(year, 2-1, 1)).getTime(),
            endTs = Date.now();
        paymentHistoryFilter = paymentHistoryFilter.filter(function (el) {
          var ts = (new Date(el.txnDate)).getTime();
            el.txnDateTemp = ts;
          return ts >= startTs && ts <= endTs;
        });
        $scope.stDate = new Date(year, 2-1, 1);
        $scope.session.accountData.paymentHistory = paymentHistoryFilter
        $scope.nextItem($scope.session.accountData.paymentHistory.length);
      }else if(exportHistory.rangeSelection === 'lastyear'){
        var lastyear = new Date(new Date().getFullYear() - 1, 0, 1);
        var startTs = (new Date(lastyear.getFullYear(), 0, 1)).getTime(),
            endTs = (new Date(lastyear.getFullYear(), 11, 31)).getTime();
        paymentHistoryFilter = paymentHistoryFilter.filter(function (el) {
          var ts = (new Date(el.txnDate)).getTime();
            el.txnDateTemp = ts;
          return ts >= startTs && ts <= endTs;
        });
        $scope.stDate = new Date(lastyear.getFullYear(), 0, 1);
        $scope.eDate = new Date(lastyear.getFullYear(), 11, 31);
        $scope.session.accountData.paymentHistory = paymentHistoryFilter;
        $scope.nextItem($scope.session.accountData.paymentHistory.length);
      }else if(exportHistory.rangeSelection === 'past12'){
        var past12 = new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate());
        past12.setFullYear(past12.getFullYear() - 1);
        var startTs = new Date(past12.getFullYear(), new Date().getMonth() + 1, new Date().getDate()).getTime(),
            endTs = Date.now();
        paymentHistoryFilter = paymentHistoryFilter.filter(function (el) {
          var ts = (new Date(el.txnDate)).getTime();
            el.txnDateTemp = ts;
          return ts >= startTs && ts <= endTs;
        });
        $scope.stDate = new Date(past12.getFullYear(), new Date().getMonth() + 1, new Date().getDate());
        $scope.session.accountData.paymentHistory = paymentHistoryFilter;
        $scope.nextItem($scope.session.accountData.paymentHistory.length);
      }
      else if(exportHistory.rangeSelection === 'past24'){
        var past24 = new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate());
        past24.setFullYear(past24.getFullYear() - 2);
        var startTs = new Date(past24.getFullYear(), new Date().getMonth() + 1, new Date().getDate()).getTime(),
            endTs = Date.now();
        paymentHistoryFilter = paymentHistoryFilter.filter(function (el) {
          var ts = (new Date(el.txnDate)).getTime();
            el.txnDateTemp = ts;
          return ts >= startTs && ts <= endTs;
        });
        $scope.stDate = new Date(past24.getFullYear(), new Date().getMonth() + 1, new Date().getDate());
        $scope.session.accountData.paymentHistory = paymentHistoryFilter;
        $scope.nextItem($scope.session.accountData.paymentHistory.length);
      } else {
        $scope.session.accountData.paymentHistory = paymentHistoryFilter;
      }
    };

    $scope.nextItem = function (len) {
      if(len > $scope.pagination.perPage){
        $scope.pagination.nextItem =  (Math.min(parseInt($scope.pagination.perPage), parseInt(len) - parseInt($scope.pagination.showing)));
        return $scope.pagination.nextItem;
      } else {
        $scope.pagination.nextItem =  Math.min(parseInt(len),parseInt($scope.pagination.showing) - parseInt(len));
        return $scope.pagination.nextItem;
      }
    };

    $scope.showItem = function (len) {
      if(len < $scope.pagination.showing){
        return len;
      }
      return $scope.pagination.showing;
    };

    $scope.next = function() {
      $scope.pagination.showing += Math.min($scope.pagination.perPage, UserSession.accountData.paymentHistory.length - $scope.pagination.showing);
    };

    //  Return true when the full Payment History is being shown
    $scope.fullList = function() {
      return $scope.pagination.showing == UserSession.accountData.paymentHistory.length;
    };
    //  Return the Transaction Date of the first transaction of the current set
    $scope.startDate = function() {
      if ($scope.session.accountData.paymentHistory[0]) {
        return $scope.session.accountData.paymentHistory[0].txnDate;
      } else {
        return "";
      }
    };
    //  Return the Transaction Date of the lsat transaction of the current set
    $scope.endDate = function() {
      if ($scope.session.accountData.paymentHistory[$scope.session.accountData.paymentHistory.length - 1]) {
        return $scope.session.accountData.paymentHistory[$scope.session.accountData.paymentHistory.length - 1].txnDate;
      } else {
        return "";
      }
    };
    $scope.transactionAmount = function(tnx) {
      if (tnx.txnType === "CHARGE") {
        return tnx.chargeAmount;
      } else if (tnx.txnType === "PAYMENT") {
        return tnx.paymentAmount;
      } else {
        return tnx.adjustmentAmount;
      }
    };
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));

  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/paymentHistory/paymentHistory.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "userSession","$rootScope","loggerService","loggerServiceHelper"];
  angular.module('cvsApp').directive('paymentHistory', directiveFunction);

  angular.module('cvsApp').filter('startCase', function() {
    return function(txt) {
      return _.startCase(txt);
    }
  })


})();
